import React from 'react';
import { Div } from '../Div';
import { PasswordMessageProps } from './types';
import { getPasswordStrength, strengthLevelToCssClass } from './helpers';

export const PasswordMessage = (props: PasswordMessageProps) => {
  const {
    value, theme, minPasswordEvaluationLength, passwordEvaluators, passwordRules,
  } = props;

  if (
    value === null
    || value.length < minPasswordEvaluationLength
  ) {
    return (
      <Div
        className={theme?.messageDefault}
      >
        { passwordRules ?? 'Use latin uppercase and lowercase letters and symbols' }
      </Div>
    );
  }

  const { strengthLevel, message } = getPasswordStrength(value, passwordEvaluators);

  return (
    <Div
      className={strengthLevelToCssClass({ strengthLevel, theme })}
    >
      {message}
    </Div>
  );
};
